import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";

export default function SubscriptionStatus({ status, approved }) {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="subtitle1">{status}</Typography>

      {approved ? (
        <CheckCircle color="success" fontSize="small" />
      ) : (
        <Tooltip title={"Not school approved"}>
          <Cancel color="error" fontSize="small" />
        </Tooltip>
      )}
    </Box>
  );
}
